@if (state.message) {
  @if (state.message.created_by_role === 'user') {
    <dojo-image-chat-user-message [message]="state.message" />
  } @else {
    <dojo-image-chat-agent-remote-message [message]="state.message" />
  }
}
